import { FeatureCode } from '@lifedot/constants/searchChoices'

export const needConditionSuffix = (conditionCode: string) =>
  ![
    FeatureCode.PET,
    FeatureCode.VIEW_STATE,
    FeatureCode.LIFETIME_REQUEST
  ].includes(conditionCode)
